// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconShrimp = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M7 6a1 1 0 11-2 0 1 1 0 012 0" />,
    <path
      fillRule="evenodd"
      d="M2 2L1 3v3.429h.018A5 5 0 006 11h7a1 1 0 011 1 2 2 0 01-2 2h-1a6.99 6.99 0 00-5.719 2.962L3.36 14.4l-1.8.6v7.416l1.8.6L4.871 21h8.314C18.571 21 23 16.78 23 11.5S18.571 2 13.185 2zm4.416 17H12v-3h-1a5 5 0 00-4.584 3M14 18.96v-3.495a4 4 0 001.353-1.283l2.97 2.97A7.93 7.93 0 0114 18.96m5.676-3.284A7.24 7.24 0 0020 7.83l-4.005 4.004Q16 11.916 16 12zm-.918-9.434L15.12 9.88A3 3 0 0014 9.17V4.04a7.9 7.9 0 014.758 2.201M12 4H3v2a3 3 0 003 3h6z"
    />
  );
export default SvgIconShrimp;
